import React from "react";
import classNames from "classnames";
import withTranslations from "../../../../../hocs/withTranslations";
import FilterOptionsHelper from "../../../../../lib/UniversalTable/CoreHelpers/FilterOptionsHelper";
import "../rendererStyles/String.scss";

const String = ({ value, format, translate, columnFontSize, attributeName }) => {
  const text =
    format === "string_translated"
      ? translate(
          FilterOptionsHelper.getOptionTranslationKey(
            { attribute_name: attributeName },
            value
          )
        )
      : value;

  return (
    <div
      className={classNames({
        "string-renderer": true,
        [`column-size-${columnFontSize}`]: !!columnFontSize
      })}
    >
      {text}
    </div>
  );
};

export default withTranslations(String);
